import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import GridOnIcon from '@mui/icons-material/GridOn';
import KeyIcon from "@mui/icons-material/Key";
import RegistrationIcon from "@mui/icons-material/HowToReg";
import TimelineIcon from "@mui/icons-material/Timeline";
import VpnLockOutlinedIcon from '@mui/icons-material/VpnLockOutlined';
import ManageSearchIcon from "@mui/icons-material/ManageSearch";

export const defaultStyle = {width: '2em', height: 'auto', marginTop: '12px'};

export const MANAGEMENT_MODULES = {
    userManagement: {
        name: 'User Management',
        icon: <PersonIcon sx={defaultStyle}/>,
        path: '/user-management',
    },
    groupManagement: {
        name: 'Group Management',
        icon: <GroupsIcon sx={defaultStyle}/>,
        path: '/group-management',
    },
    modulePermission: {
        name: 'Module Permission',
        icon: <AutoStoriesIcon sx={defaultStyle}/>,
        path: '/module-permission',
    },
    modulePermissionMatrix: {
        name: 'Module Permission Matrix',
        icon: <GridOnIcon sx={defaultStyle}/>,
        path: '/module-permission-matrix',
    },
    permissionManagement: {
        name: 'Dashboard Permissions',
        icon: <KeyIcon sx={defaultStyle}/>,
        path: '/permission-management',
    },
    registrations: {
        name: 'Registrations',
        icon: <RegistrationIcon sx={defaultStyle}/>,
        path: '/registration-management',
    },
    loginHistory: {
        name: 'Login History',
        icon: <TimelineIcon sx={defaultStyle}/>,
        path: '/login-history',
    },
    wafManagement: {
        name: 'WAF Management',
        icon: <VpnLockOutlinedIcon sx={defaultStyle}/>,
        path: '/waf-management',
    },
    dashboardUsageMonitoring: {
        name: 'Dashboard Usage Monitoring',
        icon: <TimelineIcon sx={defaultStyle}/>,
        path: '/dashboard-usage-monitoring',
    },
    userAudit: {
        name: 'User Audit',
        icon: <ManageSearchIcon sx={defaultStyle}/>,
        path: '/user-audit',
    },
};

/**
 * Top-level feature/navigation routes that are not admin tools and not in DASHBOARD_GROUPS.
 * These are shown in the main nav or are otherwise significant standalone features.
 */
export const FEATURE_MODULES = [
    { name: 'Main Dashboard',       path: '/dashboard' },
    { name: 'Admin Management',     path: '/admin-management' },
    { name: 'Chart Gallery',        path: '/chart-gallery' },
    { name: 'Dashboard Editor',     path: '/dashboard-editor' },
    { name: 'Data Explorer',        path: '/data-explorer' },
    { name: 'Campaign Creation',    path: '/campaign-creation' },
    { name: 'Campaign List',        path: '/campaign-list' },
    { name: 'Curated Analytics',    path: '/others/curated-analytics' },
];

/**
 * Experimental / less-visible routes that exist in the router but are not in main navigation.
 * Listed here so they can be optionally registered.
 */
export const EXPERIMENTAL_MODULES = [
    { name: 'Customer Analytics',              path: '/customer-analytics' },
    { name: 'Chat-Enabled Customer Analytics', path: '/chat-enabled-customer-analytics' },
    { name: 'Channel Analytics',               path: '/channel-analytics' },
    { name: 'Category Analytics',              path: '/category-analytics' },
    { name: 'Looker Studio Test',              path: '/others/looker-studio-test' },
    { name: 'Data Monitoring',                 path: '/others/data-monitoring' },
];
